<template>
  <div class="banner">
    <div class="slogan">
      <div class="slogan__desc"></div>
      <div class="play-btn" @click="openVideoBox"></div>
    </div>
    <template v-if="stage == 0">
      <div class="reservation">
        <span class="text">已有</span>
        <span class="count">{{ reserveCount }}</span>
        <span class="text">人预约《从前有条街》</span>
      </div>
      <div class="reserve">
        <div class="reserve__btn reserve--official" @click="openReserveDialog" :class="{ finished: isReserved }"></div>
        <div class="reserve__btn reserve--taptap" @click="openLink"></div>
      </div>
    </template>
    <template v-else-if="stage == 1">
      <!-- <div class="download">
        <div class="download__btn" @click="mobileDownload()"></div>
        <div class="download__btn" @click="download('taptap')"></div>
      </div> -->
      <div class="download-btn__group">
        <div class="download-btn__item thunder" @click="openDownloadLink('thunder')"></div>
        <div class="download-btn__item mumu" @click="openDownloadLink('mumu')"></div>
        <div class="download-btn__item taptap" @click="openDownloadLink('taptap')"></div>
        <div class="download-btn__item hykb" @click="openDownloadLink('hykb')"></div>
      </div>
    </template>
    <video-box :visible.sync="videoBoxVisible" :src="video" />
  </div>
</template>

<script>
import VideoBox from './components/VideoBox.vue'

import bannerMixins from '@/mixins/home/bannerMixins.js'

import { isIOS } from '@/utils/common.js'

export default {
  name: 'MobileBanner',
  mixins: [bannerMixins],
  components: {
    VideoBox,
  },
  methods: {
    mobileDownload() {
      // 根据移动端操作系统下载对应游戏包
      if (isIOS()) {
        this.download('ios')
      } else {
        this.download('android')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: 174.4vw;
  background: url('~@/assets/img/mobile/banner_bg.jpg') no-repeat;
  background-size: 100%;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 21.466666vw;
    background: url('~@/assets/img/mobile/banner_cover.png') no-repeat;
    background-size: 100%;
  }
}

.slogan {
  position: absolute;
  top: 15vw;
  right: 10vw;
  width: 35.6vw;
  height: 76vw;
  background: url('~@/assets/img/mobile/slogan1.png') no-repeat;
  background-size: 100%;
}

.play-btn {
  position: absolute;
  top: 2vw;
  right: 18vw;
  width: 10.4vw;
  height: 10.4vw;

  &::before {
    content: '';
    display: block;
    width: 10.4vw;
    height: 10.4vw;
    background: url('~@/assets/img/common/play_btn.png') no-repeat;
    background-size: 12.933333vw 10.4vw;
    animation: rotate 10s linear infinite;
  }

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 2.533333vw;
    height: 2.933333vw;
    background: url('~@/assets/img/common/play_btn.png') no-repeat;
    background-size: 12.933333vw 10.4vw;
    background-position: -10.4vw 0;
  }
}

.reservation {
  position: absolute;
  bottom: 45.7vw;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 89.866666vw;
  height: 7.466666vw;
  background: url('~@/assets/img/common/people_bg.png') no-repeat;
  background-size: 100%;

  .text {
    font-size: 3.466666vw;
    letter-spacing: .4vw;
    color: transparent;
    background-image: linear-gradient(180deg, #ffffff, #ffedab);
    background-clip: text;
  }

  .count {
    margin: 0 2vw;
    color: #ffd851;
    font-size: 5.333333vw;
    -webkit-text-stroke: .133333vw #000;
  }
}

.reserve,
.download {
  position: absolute;
  bottom: 13.6vw;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  width: 53.2vw;

  &__btn {
    width: 100%;
    height: 12.266666vw;

    &:not(:last-of-type) {
      margin-bottom: 2.266666vw;
    }
  }
}

.reserve {
  &--official {
    background: url('~@/assets/img/mobile/reserve_btn1.png') no-repeat;
    background-size: 100%;

    &.finished {
      background: url('~@/assets/img/mobile/reserve_btn3.png') no-repeat;
    background-size: 100%;
    }
  }

  &--taptap {
    background: url('~@/assets/img/mobile/reserve_btn2.png') no-repeat;
    background-size: 100%;
  }
}

.download__btn {
  &:first-of-type {
    background: url('~@/assets/img/mobile/download_btn1.png') no-repeat;
    background-size: 100%;
  }

  &:last-of-type {
    background: url('~@/assets/img/mobile/download_btn2.png') no-repeat;
    background-size: 100%;
  }
}

.download-btn {
  &__group {
    z-index: 1;
    position: absolute;
    left: 50%;
    bottom: 30vw;
    transform: translateX(-50%);
    display: flex;
  }

  &__item {
    margin-right: 5vw;
    width: 18vw;
    height: 18vw;
    background-size: 100%;
    background-repeat: no-repeat;
    cursor: pointer;

    &:last-of-type {
      margin-right: 0;
    }

    &.thunder {
      background-image: url('~@/assets/img/mobile/btn1_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/mobile/btn1_active.png');
      }
    }
    &.mumu {
      background-image: url('~@/assets/img/mobile/btn2_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/mobile/btn2_active.png');
      }
    }
    &.taptap {
      background-image: url('~@/assets/img/mobile/btn3_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/mobile/btn3_active.png');
      }
    }
    &.hykb {
      background-image: url('~@/assets/img/mobile/btn4_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/mobile/btn4_active.png');
      }
    }
  }
}
</style>